import { render, staticRenderFns } from "./PrintCertificate.vue?vue&type=template&id=e8479ade&scoped=true"
import script from "./PrintCertificate.vue?vue&type=script&lang=js"
export * from "./PrintCertificate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8479ade",
  null
  
)

export default component.exports